import { v4 as uuid } from 'uuid';
import { exportTargetsByType, exportType, MatchingOperator } from '../constants';
import type { AudienceForm } from '../types';

export const getInitialValues = (accountId: string): AudienceForm => {
  return {
    name: '',
    description: '',
    account_id: accountId,
    export_type: exportType.OA_MATCH,
    export_targets: exportTargetsByType[exportType.OA_MATCH],
    direct_audience_provider: null,
    normalized_definition: {
      excludes: {
        groups: [{ uuid: uuid(), operator: MatchingOperator.INTERSECTION }],
        operator: MatchingOperator.INTERSECTION,
      },
      includes: {
        groups: [{ uuid: uuid(), operator: MatchingOperator.INTERSECTION }],
        operator: MatchingOperator.UNION,
      },
    },
    audience_share: [],
  };
};
